export default "__VITE_ASSET__BlEgc15f__"